export enum CHANNELS_PLATFORMS {
  DISPLAY = 'display',
  SEARCH = 'search',
  SOCIAL = 'social',
  VIDEO = 'video',
  NATIVE = 'native',
  ADDRESSABLE_TV = 'addressableTv',
  DIGITAL_OUT_OF_HOME = 'dooh',
  PROGRAMMATIC_RADIO = 'programmaticRadio',
  DEM = 'dem',
  SMS = 'sms',
  PUSH = 'push',
  MOBILE = 'mobile',
  OOH = 'ooh',

  DV360 = 'dv360',
  FACEBOOK = 'facebook',
  ADWORDS = 'googleads',
  APPNEXUS = 'appnexus',
  ADFORM = 'adform',
  SIZMEK = 'sizmek',
  THE_TRADE_DESK = 'theTradeDesk',
  OATH = 'oath',
  CRITEO = 'criteo',
  AMAZON = 'amazon',
  HYBRID_AI = 'hybridAi',
  INSTAL = 'instal',
  YOUTUBE = 'youtube',
  INSTAGRAM = 'instagram',
  TWITTER = 'twitter',
  LINKEDIN = 'linkedin',
  VK_COM = 'vkCom',
  XING = 'xing',
  PINTEREST = 'pinterest',
  WHATSAPP_BUSINESS = 'whatsappBusiness',
  MAKEMEREACH = 'makemereach',
  WECHAT = 'wechat',
  WEIBO = 'weibo',
  BING = 'bing',
  YANDEX = 'yandex',
  YAHOO = 'yahoo',
  BAIDU = 'baidu',
}

export const channelPlatformNamesMap = {
  displayCampaign: CHANNELS_PLATFORMS.DISPLAY,
  searchCampaign: CHANNELS_PLATFORMS.SEARCH,
  socialCampaign: CHANNELS_PLATFORMS.SOCIAL,
  videoCampaign: CHANNELS_PLATFORMS.VIDEO,
  emailCampaign: CHANNELS_PLATFORMS.DEM,

  display: CHANNELS_PLATFORMS.DISPLAY,
  search: CHANNELS_PLATFORMS.SEARCH,
  social: CHANNELS_PLATFORMS.SOCIAL,
  video: CHANNELS_PLATFORMS.VIDEO,
  native: CHANNELS_PLATFORMS.NATIVE,
  addressableTv: CHANNELS_PLATFORMS.ADDRESSABLE_TV,
  digitalOutOfHome: CHANNELS_PLATFORMS.DIGITAL_OUT_OF_HOME,
  dooh: CHANNELS_PLATFORMS.DIGITAL_OUT_OF_HOME,
  ooh: CHANNELS_PLATFORMS.OOH,
  email: CHANNELS_PLATFORMS.DEM,
  sms: CHANNELS_PLATFORMS.SMS,
  push: CHANNELS_PLATFORMS.PUSH,
  dem: CHANNELS_PLATFORMS.DEM,
  programmaticRadio: CHANNELS_PLATFORMS.PROGRAMMATIC_RADIO,
  mobile: CHANNELS_PLATFORMS.MOBILE,
  mobileApp: CHANNELS_PLATFORMS.MOBILE,

  dv360: CHANNELS_PLATFORMS.DV360,
  dbm: CHANNELS_PLATFORMS.DV360,
  facebook: CHANNELS_PLATFORMS.FACEBOOK,
  adwords: CHANNELS_PLATFORMS.ADWORDS,
  googleAds: CHANNELS_PLATFORMS.ADWORDS,
  appnexus: CHANNELS_PLATFORMS.APPNEXUS,
  adform: CHANNELS_PLATFORMS.ADFORM,
  sizmek: CHANNELS_PLATFORMS.SIZMEK,
  theTradeDesk: CHANNELS_PLATFORMS.THE_TRADE_DESK,
  oath: CHANNELS_PLATFORMS.OATH,
  criteo: CHANNELS_PLATFORMS.CRITEO,
  amazon: CHANNELS_PLATFORMS.AMAZON,
  hybridAi: CHANNELS_PLATFORMS.HYBRID_AI,
  instal: CHANNELS_PLATFORMS.INSTAL,
  youtube: CHANNELS_PLATFORMS.YOUTUBE,
  instagram: CHANNELS_PLATFORMS.INSTAGRAM,
  twitter: CHANNELS_PLATFORMS.TWITTER,
  linkedin: CHANNELS_PLATFORMS.LINKEDIN,
  vkCom: CHANNELS_PLATFORMS.VK_COM,
  xing: CHANNELS_PLATFORMS.XING,
  pinterest: CHANNELS_PLATFORMS.PINTEREST,
  whatsappBusiness: CHANNELS_PLATFORMS.WHATSAPP_BUSINESS,
  makemereach: CHANNELS_PLATFORMS.MAKEMEREACH,
  wechat: CHANNELS_PLATFORMS.WECHAT,
  weibo: CHANNELS_PLATFORMS.WEIBO,
  bing: CHANNELS_PLATFORMS.BING,
  yandex: CHANNELS_PLATFORMS.YANDEX,
  yahoo: CHANNELS_PLATFORMS.YAHOO,
  baidu: CHANNELS_PLATFORMS.BAIDU,
};
